/* Teksty interfejsu: assets/json/i18n/{lang}/js-runtime.json. */
function jst(key, params, language) {
    var api = typeof globalThis !== 'undefined' ? globalThis.PewniakiI18n : null;
    if (api && typeof api.t === 'function') return api.t(key, params);
    if (typeof module === 'object' && module.exports && typeof require === 'function') {
        var lang = language || (typeof document !== 'undefined' && /^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'en' : 'pl');
        var dict = require('../../json/i18n/' + lang + '/js-runtime.json');
        var text = Object.prototype.hasOwnProperty.call(dict, key) ? String(dict[key]) : key;
        return (params || []).reduce(function (out, value, index) { return out.split('%' + (index + 1)).join(String(value)); }, text);
    }
    return key;
}

/* Systemy pelne — czysty modul: kombinacje, liczba zakladow, CSV.
 *
 * Bez DOM, bez sieci. Uzywany przez systemy.html.twig (rozpiska kuponow
 * i eksport CSV) oraz przez bin/test-kalkulatory.js (testy wlasciwosci).
 * Zadnych danych uzytkownika na serwerze: wszystko liczy sie w przegladarce.
 *
 *   count(n, k)                 — C(n,k), dokladnie (safe integer) albo null
 *   losuj(ile, pula)            — `ile` roznych liczb 1..pula, posortowane
 *   combos(numbers, k)          — wszystkie k-elementowe podzbiory, porzadek
 *                                 leksykograficzny po POSORTOWANYCH liczbach;
 *                                 deterministyczny: UI i CSV daja ten sam zbior
 *   cartesian(main, extra)      — iloczyn dwoch list kombinacji (Eurojackpot)
 *   validate(numbers, n, pool)  — {ok, blad}: dokladnie n roznych liczb 1..pool
 *   csv(opcje)                  — napis CSV z BOM UTF-8 (Excel), srednik jako
 *                                 separator (polski Excel), CRLF
 *
 *   kombinacjaNr(numbers,k,i)   — i-ta kombinacja w porzadku combos() bez
 *                                 budowania calej listy (unranking)
 *   losoweIndeksy(ile, razem)   — `ile` ROZNYCH indeksow 0..razem-1, rosnaco;
 *                                 crypto.getRandomValues, bez stronniczego modulo
 *   zestawBudzetowy(o)          — ZESTAW BUDZETOWY (Systemy UX B, 24.09.2026):
 *                                 `ile` roznych zakladow wylosowanych z systemu
 *                                 pelnego wybranych liczb. Losowy podzbior BEZ
 *                                 GWARANCJI pokrycia — nie jest ukladem
 *                                 skroconym z gwarancja i tak ma byc opisany.
 *
 * LIMIT: combos() odmawia powyzej MAX_KUPONOW (210) — to samo ograniczenie
 * ma lista w UI; liczba zakladow i koszt licza sie bez limitu przez count().
 * Zestaw budzetowy tez ma najwyzej MAX_KUPONOW zakladow, ale system pelny,
 * z ktorego losuje, moze byc wiekszy: nie materializujemy go — losujemy
 * numery kombinacji i odtwarzamy tylko wybrane (kombinacjaNr).
 */
(function (root) {
    'use strict';

    // Wieksza rozpiska jest nieczytelna i niepotrzebnie obciaza DOM/druk/CSV.
    // Limit jest wspolny dla wszystkich gier oraz systemow pelnych i skroconych.
    var MAX_KUPONOW = 210;

    function czyCalkowita(x) {
        return typeof x === 'number' && isFinite(x) && x % 1 === 0;
    }

    function count(n, k) {
        if (!czyCalkowita(n) || !czyCalkowita(k) || n < 0 || k < 0) return null;
        if (k > n) return 0;
        if (k === 0 || k === n) return 1;
        if (k > n - k) k = n - k;
        var r = 1;
        for (var i = 1; i <= k; i++) r = r * (n - k + i) / i;
        r = Math.round(r);
        return Number.isSafeInteger(r) ? r : null;
    }

    /* Losowanie liczb do formularza (przycisk „losuj liczby", 19.09.2026).
     * crypto.getRandomValues z odrzucaniem ogona zakresu, nie `% max` na
     * gotowej liczbie: modulo po surowym losie faworyzuje poczatek puli.
     * Ten sam sposob ma generator chybil-trafil (generator.html.twig). */
    function losowaDo(max) {
        var c = root.crypto || root.msCrypto;
        if (c && c.getRandomValues) {
            var granica = Math.floor(4294967296 / max) * max, buf = new Uint32Array(1), x;
            do { c.getRandomValues(buf); x = buf[0]; } while (x >= granica);
            return x % max;
        }
        return Math.floor(Math.random() * max);   // stara przegladarka
    }

    function losuj(ile, pula) {
        if (!czyCalkowita(ile) || !czyCalkowita(pula) || ile < 1 || pula < ile) return null;
        var wolne = [], out = [];
        for (var i = 1; i <= pula; i++) wolne.push(i);
        while (out.length < ile) out.push(wolne.splice(losowaDo(wolne.length), 1)[0]);
        return out.sort(function (a, b) { return a - b; });
    }

    function validate(numbers, n, pool) {
        if (!Array.isArray(numbers)) return { ok: false, blad: 'liczba' };
        var unikalne = numbers.filter(function (v, i, a) { return czyCalkowita(v) && a.indexOf(v) === i; });
        if (numbers.length !== n || unikalne.length !== n) return { ok: false, blad: 'liczba' };
        for (var i = 0; i < unikalne.length; i++) {
            if (unikalne[i] < 1 || unikalne[i] > pool) return { ok: false, blad: 'zakres' };
        }
        return { ok: true, liczby: unikalne.slice().sort(function (a, b) { return a - b; }) };
    }

    // Kanoniczne mapowanie certyfikowanego układu: indeks 1..n zawsze
    // oznacza tę samą pozycję w rosnąco posortowanych liczbach użytkownika.
    function mapLayout(numbers, layout) {
        var sorted = numbers.slice().sort(function (a, b) { return a - b; });
        if (!layout || sorted.length !== layout.n || !Array.isArray(layout.blocks)) return null;
        var out = [];
        for (var i = 0; i < layout.blocks.length; i++) {
            if (!Array.isArray(layout.blocks[i]) || layout.blocks[i].length !== layout.k) return null;
            var row = [];
            for (var j = 0; j < layout.blocks[i].length; j++) {
                var idx = layout.blocks[i][j] - 1;
                if (idx < 0 || idx >= sorted.length) return null;
                row.push(sorted[idx]);
            }
            out.push(row.sort(function (a, b) { return a - b; }));
        }
        return out;
    }

    function combos(numbers, k) {
        var zrodlo = numbers.slice().sort(function (a, b) { return a - b; });
        var razem = count(zrodlo.length, k);
        if (razem === null || razem > MAX_KUPONOW) return null;
        var out = [], biezaca = [];
        (function krok(start) {
            if (biezaca.length === k) { out.push(biezaca.slice()); return; }
            var potrzeba = k - biezaca.length;
            for (var i = start; i <= zrodlo.length - potrzeba; i++) {
                biezaca.push(zrodlo[i]);
                krok(i + 1);
                biezaca.pop();
            }
        })(0);
        return out;
    }

    function cartesian(main, extra) {
        if (!Array.isArray(main) || !Array.isArray(extra)) return null;
        if (main.length * extra.length > MAX_KUPONOW) return null;
        var out = [];
        for (var i = 0; i < main.length; i++) {
            for (var j = 0; j < extra.length; j++) {
                out.push({ liczby: main[i].slice(), euro: extra[j].slice() });
            }
        }
        return out;
    }

    function pole(v) {
        v = String(v);
        // Excel/LibreOffice traktują początek = + - @ jako formułę. Eksport
        // jest lokalny, ale tekstowe metadane nadal neutralizujemy.
        if (/^[=+\-@]/.test(v)) v = "'" + v;
        return /[;"\r\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v;
    }

    // `euro` zachowuje zgodnosc ze starym wywolaniem (stala para).
    // Pelny Eurojackpot podaje `euroLiczby` i rownolegla liste `euroKupony`.
    function csv(o) {
        var en = o.lang === 'en';
        function label(key) { return jst(key, [], en ? 'en' : 'pl'); }
        var SEP = ';', EOL = '\r\n';
        var wiersze = [];
        wiersze.push([label("kalkulatory_systemy_js.fe3a20577c4c"), o.nazwa || o.gra].map(pole).join(SEP));
        // `o.system` = opis rodzaju (zestaw budzetowy); domyslnie system pelny.
        wiersze.push([label("kalkulatory_systemy_js.d13a5773a17d"), (o.system ? o.system + ', ' : label("kalkulatory_systemy_js.c81a079d1bb2")) + o.n + label("kalkulatory_systemy_js.55fdce0e72d8") + o.k].map(pole).join(SEP));
        if (o.uwaga) wiersze.push([label("kalkulatory_systemy_js.7e3950572f37"), o.uwaga].map(pole).join(SEP));
        wiersze.push([label("kalkulatory_systemy_js.64012a24c978"), o.liczby.join(' ')].map(pole).join(SEP));
        var euroWybrane = o.euroLiczby && o.euroLiczby.length ? o.euroLiczby : o.euro;
        var euroPierwsze = o.euroKupony && o.euroKupony.length ? o.euroKupony[0] : o.euro;
        if (euroWybrane && euroWybrane.length) wiersze.push([label("kalkulatory_systemy_js.0440cc188b58"), euroWybrane.join(' ')].map(pole).join(SEP));
        wiersze.push([label("kalkulatory_systemy_js.0a3d607c8a92"), o.kupony.length].map(pole).join(SEP));
        if (typeof o.cena === 'number' && isFinite(o.cena)) {
            wiersze.push([label("kalkulatory_systemy_js.45a3063849ce"), (o.kupony.length * o.cena).toFixed(2).replace('.', en ? '.' : ',')].map(pole).join(SEP));
        }
        wiersze.push('');
        var naglowek = [label("kalkulatory_systemy_js.b81feb634775")];
        for (var i = 1; i <= o.k; i++) naglowek.push(label("kalkulatory_systemy_js.d2c1bbf4d3db") + i);
        if (euroPierwsze && euroPierwsze.length) for (var e = 1; e <= euroPierwsze.length; e++) naglowek.push(label("kalkulatory_systemy_js.af2cf6f72931") + e);
        wiersze.push(naglowek.map(pole).join(SEP));
        for (var j = 0; j < o.kupony.length; j++) {
            var w = [j + 1].concat(o.kupony[j]);
            var euroWiersza = o.euroKupony && o.euroKupony[j] ? o.euroKupony[j] : o.euro;
            if (euroWiersza && euroWiersza.length) w = w.concat(euroWiersza);
            wiersze.push(w.map(pole).join(SEP));
        }
        return '﻿' + wiersze.join(EOL) + EOL;
    }

    /* i-ta (od 0) kombinacja k-elementowa POSORTOWANYCH liczb, w tym samym
     * porzadku leksykograficznym co combos(). null dla zlego indeksu. */
    function kombinacjaNr(numbers, k, idx) {
        var zrodlo = numbers.slice().sort(function (a, b) { return a - b; });
        var n = zrodlo.length, razem = count(n, k);
        if (razem === null || !czyCalkowita(idx) || idx < 0 || idx >= razem) return null;
        var out = [], start = 0;
        for (var poz = 0; poz < k; poz++) {
            for (var i = start; i < n; i++) {
                var reszta = count(n - i - 1, k - poz - 1);
                if (idx < reszta) { out.push(zrodlo[i]); start = i + 1; break; }
                idx -= reszta;
            }
        }
        return out;
    }

    /* `ile` roznych indeksow z 0..razem-1, rosnaco. Przy malej czesci puli
     * losowanie z odrzucaniem powtorek; przy duzej czesciowy Fisher-Yates
     * (wtedy razem < 2*MAX_KUPONOW, wiec tablica jest mala). */
    function losoweIndeksy(ile, razem) {
        if (!czyCalkowita(ile) || !czyCalkowita(razem) || ile < 1 || ile > razem || razem > 4294967295) return null;
        var out = [];
        if (ile * 2 <= razem) {
            var bylo = {};
            while (out.length < ile) {
                var x = losowaDo(razem);
                if (!bylo[x]) { bylo[x] = true; out.push(x); }
            }
        } else {
            var t = [];
            for (var i = 0; i < razem; i++) t.push(i);
            for (var j = 0; j < ile; j++) {
                var r = j + losowaDo(razem - j), tmp = t[j];
                t[j] = t[r]; t[r] = tmp;
                out.push(t[j]);
            }
        }
        return out.sort(function (a, b) { return a - b; });
    }

    /* o = { liczby, k, ile, euroLiczby? }. Wynik: { razem, pelny, bilety }
     * albo { blad: 'zakres' | 'limit' } — `ile` spoza 1..min(razem, MAX).
     * Eurojackpot: przestrzen = pary (kombinacja glowna, para euro), indeks
     * i -> glowna i / C(e,2), euro i % C(e,2) — ten sam zbior co cartesian(). */
    function zestawBudzetowy(o) {
        var k = o.k, glowne = count(o.liczby.length, k);
        var euro = o.euroLiczby && o.euroLiczby.length ? o.euroLiczby.slice().sort(function (a, b) { return a - b; }) : null;
        var ce = euro ? count(euro.length, 2) : 1;
        if (glowne === null || ce === null || !Number.isSafeInteger(glowne * ce)) return { blad: 'limit' };
        var razem = glowne * ce;
        if (!czyCalkowita(o.ile) || o.ile < 1 || o.ile > razem) return { blad: 'zakres', razem: razem };
        if (o.ile > MAX_KUPONOW) return { blad: 'limit', razem: razem };
        var idx = losoweIndeksy(o.ile, razem);
        if (!idx) return { blad: 'limit', razem: razem };
        var bilety = idx.map(function (i) {
            return {
                liczby: kombinacjaNr(o.liczby, k, euro ? Math.floor(i / ce) : i),
                euro: euro ? kombinacjaNr(euro, 2, i % ce) : null
            };
        });
        return { razem: razem, pelny: o.ile === razem, bilety: bilety };
    }

    var api = { count: count, combos: combos, cartesian: cartesian, validate: validate, csv: csv, losuj: losuj, mapLayout: mapLayout,
        kombinacjaNr: kombinacjaNr, losoweIndeksy: losoweIndeksy, zestawBudzetowy: zestawBudzetowy, MAX_KUPONOW: MAX_KUPONOW };

    if (typeof module === 'object' && module && module.exports) module.exports = api;
    root.PewniakiSystemy = api;
})(typeof globalThis !== 'undefined' ? globalThis : this);
